import React from 'react';
import Header from '../components/Header';
import Button from '../components/Button';

const ThanksPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="container mx-auto px-4 py-8 max-w-2xl">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Merci !
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Nous avons bien reçu votre demande. Nous reviendrons vers vous rapidement.
          </p>
          <a 
            href="https://smart-impact.ch" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button variant="secondary">
              Découvrir nos services
            </Button>
          </a>
        </div>
      </main>
    </div>
  );
};

export default ThanksPage;